import Chevron from '../../../navigationMenu/components/chevron';
import { dialogModalHandler } from 'src/utils/helpers';
import { isAllow } from '../../../../../../utils/helpers';
import { IUser } from 'src/utils/interfaces/user';
import { NavLink } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

interface IArgs {
    path: string;
    name: string;
    icon?: string;
    dealer?: string;
    permissions?: Array<string>;
    permissionsMap: Map<string, Array<string>>;
    childs?: Array<{ name: string; path: string; permissions?: Array<string> }>;
    handler?: any;
    selected?: string;
    selectedIcon?: string;
    onNavigate?: () => void;
}

const MenuItem = ({
    path,
    name,
    icon,
    childs,
    handler,
    selected,
    selectedIcon,
    dealer,
    permissions,
    permissionsMap,
    onNavigate,
}: IArgs) => {
    const { t } = useTranslation();
    const dialogModal = useSelector((state: IUser) => {
        return state.dialogModal;
    });
    const dispatch = useDispatch();

    if (childs && childs.length) {
        return (
            <li className={'menu-items'} key={name}>
                <a
                    className='accordion__title'
                    onClick={() => {
                        handler();
                    }}
                >
                    {icon && (
                        <i
                            className={`c-icon-list__icon c-icon c-icon--[${icon}]`}
                            aria-hidden='true'
                            role='img'
                        />
                    )}
                    <span dangerouslySetInnerHTML={{ __html: t(name) }} />
                    <span>
                        <Chevron width={10} fill={'#777'} />
                    </span>
                </a>
            </li>
        );
    }

    const shouldRender = permissions
        ? isAllow(permissions, permissionsMap, dealer)
        : true;
    return shouldRender ? (
        <li className={'menu-items'}>
            {path ? (
                <NavLink
                    to={path}
                    onClick={(event) => {
                        dialogModalHandler(event, dispatch, dialogModal);
                        onNavigate?.();
                    }}
                >
                    {icon && (
                        <i
                            className={`c-icon-list__icon c-icon c-icon--[${icon}]`}
                            aria-hidden='true'
                            role='img'
                        />
                    )}
                    <span dangerouslySetInnerHTML={{ __html: t(name) }} />
                </NavLink>
            ) : (
                <a
                    className={`${
                        name.startsWith(selected ?? '') ? 'active' : ''
                    } selectable`}
                    onClick={() => (handler ? handler() : '')}
                >
                    {icon && (
                        <i
                            className={`c-icon-list__icon c-icon c-icon--[${icon}]`}
                            aria-hidden='true'
                            role='img'
                        />
                    )}
                    <span dangerouslySetInnerHTML={{ __html: t(name) }} />
                    {name.startsWith(selected ?? '') && selectedIcon && (
                        <i
                            className={`c-icon-list__icon c-icon c-icon--[${selectedIcon}]`}
                            aria-hidden='true'
                            role='img'
                        />
                    )}
                </a>
            )}
        </li>
    ) : null;
};

export default MenuItem;
